// import PropTypes from 'prop-types'
import { forwardRef, useId } from 'react'

import Text from 'components/Text'

import { CheckMark, Input, InputWrapper, Label, Root } from './CheckboxInput.style'
import CheckSvg from './svg/check.svg'

const CheckboxInput = forwardRef(({ label, ...props }, ref) => {
  const id = useId()

  return (
    <Root>
      <InputWrapper>
        <Input ref={ref} id={id} type="checkbox" {...props} />
        <CheckMark>
          <CheckSvg width={15} height={15} />
        </CheckMark>
      </InputWrapper>
      <Label htmlFor={id}>
        <Text>{label}</Text>
      </Label>
    </Root>
  )
})

CheckboxInput.propTypes = {}

CheckboxInput.defaultProps = {}

CheckboxInput.displayName = 'CheckboxInput'

export default CheckboxInput
